<template>
  <div class="orders-list">
    <h2>Orders</h2>
    <div style="margin-bottom: 20px; display: flex">
      <div style="flex:1; margin-right: 20px;" class="control has-icons-left">
        <span class="icon is-small is-right">
          <i class="fas fa-search"></i>
        </span>
        <input
          class="input has-icons-left"
          type="text"
          v-model="orderSearch"
          v-on:keyup="searchOrders"
          placeholder="Search by name or email"
        />
      </div>
      <div><button class="button" @click="exportCsv">Export CSV</button></div>
    </div>
    <table class="table is-fullwidth orders-table">
      <thead>
        <tr>
          <th>
            <span class="is-hidden-mobile">Order Created</span
            ><span class="is-hidden-tablet">Created</span>
          </th>
          <th>Name</th>
          <th class="is-hidden-mobile">Email</th>
          <th class="is-hidden-mobile">Discount Code</th>
          <th class="qty-col">Qty</th>
          <th class="is-hidden-mobile">Donation</th>
          <th>Total</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="order in visibleOrders"
          :key="order.id"
          class="clickable-row"
          @click="showOrderDetails(order)"
        >
          <td class="date-cell">
            <span class="is-hidden-mobile">{{
              order.created
                ? moment(order.created.toDate()).format("M/D/YY LT")
                : ""
            }}</span>
            <span class="is-hidden-tablet">
              <span class="date-part">{{
                order.created
                  ? moment(order.created.toDate()).format("M/D")
                  : ""
              }}</span>
              <span class="time-part">{{
                order.created ? moment(order.created.toDate()).format("LT") : ""
              }}</span>
            </span>
          </td>
          <td class="name-cell">
            <span class="name-part"
              >{{ order.firstName }} {{ order.lastName }}</span
            >
            <span class="email-part is-hidden-tablet">{{ order.email }}</span>
          </td>
          <td class="is-hidden-mobile">{{ order.email }}</td>
          <td class="is-hidden-mobile">{{ order.discountCode }}</td>
          <td class="qty-col">{{ order.quantity }}</td>
          <td class="is-hidden-mobile">{{ order.donation }}</td>
          <td>${{ order.total.toFixed(2) }}</td>
        </tr>
      </tbody>
    </table>
    <Paginator
      @pageChanged="setOrdersPage"
      :pageSize="10"
      :itemCount="
        filteredOrders.length > 0 ? filteredOrders.length : orders.length
      "
    />
  </div>
</template>

<script>
import moment from "moment";
import Paginator from "@/components/paginator";

export default {
  data: function() {
    return {
      moment: moment,
      orderPage: 1,
      orderSearch: "",
      filteredOrders: []
    };
  },
  props: {
    orders: Array,
    pageSize: Number,
    exportName: String
  },
  components: {
    Paginator
  },
  computed: {
    visibleOrders() {
      const showorders =
        this.orderSearch != "" ? this.filteredOrders : this.orders;
      const begin = (this.orderPage - 1) * 10;
      // console.log(begin);
      const lastorder =
        begin + 10 < showorders.length - 1 ? begin + 10 : showorders.length;
      console.log("slicing", begin, lastorder);
      return showorders.slice(begin, lastorder);
    }
  },
  methods: {
    setOrdersPage(page) {
      // console.log("pageset", page);
      this.orderPage = page;
    },
    showOrderDetails(order) {
      this.$emit("showOrderDetails", order);
    },
    exportCsv() {
      console.log("exporrting");
      let csvContent = "data:text/csv;charset=utf-8,";
      csvContent +=
        "Order Created,Order ID,First Name,Last Name,Email,Quantity,Discount Code,Donation,Subtotal,Total,Total After Fees,Payment Intent ID\r\n";
      this.orders.forEach(function(line) {
        const net = (Math.round(line.total * 95) / 100).toFixed(2);
        csvContent +=
          line.created.toDate() +
          "," +
          line.orderId +
          "," +
          line.firstName +
          "," +
          line.lastName +
          "," +
          line.email +
          "," +
          line.quantity +
          "," +
          line.discountCode +
          "," +
          line.donation +
          "," +
          line.subtotal +
          "," +
          line.total +
          "," +
          net +
          "," +
          line.paymentIntent +
          "\r\n";
      });
      // console.log(csvContent);
      // const exportname = this.event.title.replace(/ /g,"") + "_orders";
      var encodedUri = encodeURI(csvContent);
      var link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      link.setAttribute("download", this.exportName + ".csv");
      document.body.appendChild(link); // Required for FF

      link.click();
    },
    searchOrders() {
      console.log("find orders", this.orderSearch);
      if (!this.orderSearch) this.filteredOrders = [];
      else {
        var foundorders = this.orders.filter(order => {
          if (
            order.email &&
            (order.email + "")
              .toUpperCase()
              .indexOf(this.orderSearch.toUpperCase()) > -1
          )
            return true;
          if (
            order.firstName &&
            (order.firstName + "")
              .toUpperCase()
              .indexOf(this.orderSearch.toUpperCase()) > -1
          )
            return true;
          if (
            order.lastName &&
            (order.lastName + "")
              .toUpperCase()
              .indexOf(this.orderSearch.toUpperCase()) > -1
          )
            return true;
          return false;
          //   string email = pass.email ? pass.email.toUpperCase : "";
          //   const first = pass.firstName ? pass.firstName.toUpperCase : "";
          //   const last = pass.lastName ? pass.lastName.toUpperCase : "";
          //   return (
          //     email.indexOf(this.passSearch.toUpperCase()) > -1 ||
          //     first.indexOf(this.passSearch.toUpperCase()) > -1 ||
          //     last.toUpperCase().indexOf(this.passSearch.toUpperCase()) > -1
          //   );
        });
        this.filteredOrders = foundorders;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/variables.scss";

.clickable-row {
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: $gray6;
  }

  &:active {
    background-color: $gray5;
  }
}

.table {
  .clickable-row:hover td {
    background-color: $gray6;
  }
}

// Mobile styles
@media screen and (max-width: 768px) {
  .orders-table {
    width: 100%;
    table-layout: fixed;

    th,
    td {
      padding: 0.5em 0.4em;
      font-size: 0.9em;
    }
  }

  .date-cell {
    .date-part {
      display: block;
    }
    .time-part {
      display: block;
      font-size: 0.85em;
      color: $gray3;
    }
  }

  .name-cell {
    .name-part {
      display: block;
    }
    .email-part {
      display: block;
      font-size: 0.85em;
      color: $gray3;
      word-break: break-all;
    }
  }

  .qty-col {
    width: 2.5em;
    text-align: center;
  }
}
</style>
